import createCachedSelector from 're-reselect';

import getDocumentById from '../layers/getDocumentById';

const getRotationAngle = createCachedSelector(
    [getDocumentById],
    (doc) => doc.rotationAngle,
)((state, documentId) => documentId);

export default getRotationAngle;
